<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useSession } from '@/composables/useSession';

const router = useRouter();
const { state, logout } = useSession();
const username = computed(() => state.username);
const isAdmin = computed(() => state.isAdmin);

async function onLogout() {
  await logout();
  router.replace({ name: 'login' });
}
</script>

<template>
  <nav>
    <RouterLink class="nav-brand" to="/"><span>🗺️</span> Research Portal</RouterLink>
    <div class="nav-right">
      <RouterLink v-if="username" class="nav-admin" to="/workshops">Workshops</RouterLink>
      <RouterLink v-if="isAdmin" class="nav-admin" to="/admin">Admin</RouterLink>
      <span v-if="username" class="nav-user">Signed in as <strong>{{ username }}</strong></span>
      <button v-if="username" class="btn-logout" type="button" @click="onLogout">Sign out</button>
    </div>
  </nav>
</template>
